import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Sparkles, Users, CalendarCheck } from 'lucide-react';

interface FeatureCard {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  description: string;
  color: string;
}

const features: FeatureCard[] = [
  {
    icon: Sparkles,
    title: 'AI Career Planner',
    description: 'Get personalized career guidance based on your skills, experience, and market trends.',
    color: 'bg-purple-100 text-purple-600'
  },
  {
    icon: Users,
    title: 'Join Talent Communities',
    description: 'Join networks curated for your specific skills and interests.',
    color: 'bg-blue-100 text-blue-600'
  },
  {
    icon: CalendarCheck,
    title: 'Instant Interview Scheduling',
    description: 'Schedule interviews directly with hiring managers.',
    color: 'bg-green-100 text-green-600'
  }
];

export function FeaturesSection() {
  return (
    <section className="py-12 px-4 md:px-6 bg-muted/30">
      <div className="container">
        <div className="text-center mb-8">
          <Badge variant="secondary" className="mb-3">Platform Features</Badge>
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl">
            One Platform for Your Entire Career Journey
          </h2>
          <p className="mt-3 max-w-2xl mx-auto text-muted-foreground md:text-lg">
            NewLoop integrates career planning, skill development, and opportunity matching into a seamless experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <Card 
              key={index} 
              className="hover:shadow-md transition-all border overflow-hidden group"
            >
              <CardContent className="p-6">
                <div className={`rounded-full w-12 h-12 flex items-center justify-center mb-4 ${feature.color} dark:bg-opacity-20`}>
                  <feature.icon className="h-6 w-6" />
                </div>
                <h3 className="text-xl font-semibold mb-2 group-hover:text-primary transition-colors">{feature.title}</h3>
                <p className="text-muted-foreground">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}